(() => {
  if (customElements.get('mm-course-preview')) return;
  customElements.define('mm-course-preview', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.stopWhenClosed = () => {
        if (!this.details?.open) this.querySelector('video')?.pause();
      };
      this.details?.addEventListener('toggle', this.stopWhenClosed);
    }
    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.stopWhenClosed);
      this.querySelector('video')?.pause();
    }
  });
})();
